import type { Prototype } from "../prototype-types";

export const chrisChappellePrototypes: Prototype[] = [
  {
    id: "brand-page-exploration",
    name: "Brand Page Exploration",
    path: "/cc/brand-page-exploration",
    description:
      "Exploring different directions for navigation sidebar on the brand page.",
    owner: "Chris Chappelle",
    createdAt: "2026-04-05",
    lastUpdated: "2026-04-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f2ad6314c58b3d625d81dcd83e897ed6374ff224833970d819e4cea6b976f27d.png",
    project: "Brand page exploration",
    figmaLink:
      "https://www.figma.com/design/o4CnnG5SxvzqejlX2L8lcM/Sidebar-explorations--brand-page-nav-?node-id=1-3626&m=dev",
    creationTool: "cursor",
  },
  {
    id: "brand-page-floating-sidebar",
    name: "Brand Page - Floating Sidebar",
    path: "/cc/brand-page-floating-sidebar",
    description:
      "Alternative brand page navigation with a floating text-only sidebar.",
    owner: "Chris Chappelle",
    createdAt: "2026-04-05",
    lastUpdated: "2026-04-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5d48fd84b7a6658dcc7388757df89d31071fe316accdcf8f232784a83aa5ac26.png",
    project: "Brand page exploration",
    figmaLink:
      "https://www.figma.com/design/o4CnnG5SxvzqejlX2L8lcM/Sidebar-explorations--brand-page-nav-?node-id=1-3626&m=dev",
    creationTool: "cursor",
  },
  {
    id: "pdp-refresh-iteration",
    name: "PDP Refresh Iteration",
    path: "/cc/pdp-refresh-iteration",
    description:
      "Product detail page refresh iteration with enhanced Compass integration, content experiments, and refined reviews experience.",
    owner: "Chris Chappelle",
    createdAt: "2026-03-19",
    lastUpdated: "2026-03-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    project: "PDP Explorations",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/26275322aa83b1a3e3f229344758f2fd4cf80fb8ee802d194c28e14c11105092.png",
    figmaLink:
      "https://www.figma.com/design/iWcP1KBvz75rMpILuZACpo/Brand-x-PDP-Sprint-%E2%80%93-Jan-2026?node-id=8873-6310",
    creationTool: "cursor",
  },
  {
    id: "pdp-refresh-iteration-r2",
    name: "PDP Refresh Iteration R2",
    path: "/cc/pdp-refresh-iteration-r2",
    description:
      "Side panel variant exploration with various add-to-cart flow experiments.",
    owner: "Chris Chappelle",
    createdAt: "2026-03-24",
    lastUpdated: "2026-04-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    project: "PDP Explorations",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/6256e9703d4ab12e647e96271f2839b4fb0a649d82099c4938f4509b50c58aea.png",
    figmaLink:
      "https://www.figma.com/design/iWcP1KBvz75rMpILuZACpo/Brand-x-PDP-Sprint-%E2%80%93-Jan-2026?node-id=8873-6310",
    creationTool: "cursor",
  },
  {
    id: "pdp-refresh-iteration-r3",
    name: "PDP Refresh Iteration R3",
    path: "/cc/pdp-refresh-iteration-r3",
    description:
      "Third iteration of PDP refresh with combined inputs when in cart and pill-style back to top indicator.",
    owner: "Chris Chappelle",
    createdAt: "2026-04-08",
    lastUpdated: "2026-04-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    project: "PDP Explorations",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/0dbf68ffa87bf45ccd87f6d1ba28a74e7c19bc82e231dcf5b1685804061489fd.png",
    figmaLink:
      "https://www.figma.com/design/iWcP1KBvz75rMpILuZACpo/Brand-x-PDP-Sprint-%E2%80%93-Jan-2026?node-id=8873-6310",
    creationTool: "claude-code",
  },
  {
    id: "pdp-content-iterations",
    name: "PDP Content Iterations",
    path: "/cc/pdp-content-iterations",
    description:
      "Content iterations for the product detail page based on the refresh design with reviews inline.",
    owner: "Chris Chappelle",
    createdAt: "2026-03-10",
    lastUpdated: "2026-04-02",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/367e7fb8f559a3737fd2af64efd01f39c57c3deaf12b9ff71d575fbde6a25729.png",
    creationTool: "claude-code",
  },
  {
    id: "pdp-infinite-scroll-mobile",
    name: "PDP infinite scroll mobile",
    path: "/cc/pdp-infinite-scroll-mobile",
    description:
      "Mobile viewport (centered phone) with infinite scroll product feed. Uses real products from compassProducts; isolated from pdp-mobile.",
    owner: "Chris Chappelle",
    createdAt: "2026-02-25",
    lastUpdated: "2026-02-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ddc4e3e592ced21fd52286ec1451a8326c19cf4d9ff5ac9ac2b00595768f29bf.png",
    figmaLink:
      "https://www.figma.com/design/nLxiPdWdXgSfWUsQKlPohB/PDP-Feed---no-dead-ends?node-id=6592-58261&t=OXsdHfkP94EFJkvs-1",
    creationTool: "cursor",
  },
  {
    id: "homepage",
    name: "Homepage",
    path: "/cc/homepage",
    description:
      "Retailer homepage pattern with welcome carousel, visual navigation, recently viewed section, and product discovery grid.",
    owner: "Chris Chappelle",
    createdAt: "2026-01-06",
    lastUpdated: "2026-01-14",
    surfaceArea: "Retailer",
    category: "template",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a68f4be2886e05cd0da989965792d5f1bcf6c1a26e5d9ec8548b68476a471e0e.png",
    creationTool: "cursor",
  },
  {
    id: "feed-content-explorations",
    name: "Feed content explorations",
    path: "/cc/feed-content-explorations",
    description: "Explorations for feed content on the retailer homepage.",
    owner: "Chris Chappelle",
    createdAt: "2026-02-03",
    lastUpdated: "2026-04-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5b02db5a8cd2664d207de5ccd1aac6eefbbf8c0d92266baf234a3e3f8deeb73d.png",
    figmaLink:
      "https://www.figma.com/design/KpxizhINPyNEMohKUfDJlP/Discovery-Feed?node-id=14500-670212&t=lORM86atXpfvCB0k-1",
    creationTool: "claude-code",
  },
  {
    id: "category-menu-styling",
    name: "Category menu styling",
    path: "/cc/category-menu-styling",
    description:
      "Faire homepage with All categories menu. Variants explore different category menu styles without affecting other prototypes.",
    owner: "Chris Chappelle",
    createdAt: "2026-02-12",
    lastUpdated: "2026-02-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/90664bf4fc1cc4c44067b79c3b13f32e5847d9997410d92f1e902dc7d2e496ce.png",
    creationTool: "cursor",
  },
  {
    id: "global-navigation",
    name: "Global Navigation",
    path: "/cc/global-navigation",
    description:
      "Explorations for global navigation. Starting point: retailer homepage (TrendsHubNav + feed content).",
    owner: "Chris Chappelle",
    createdAt: "2026-02-13",
    lastUpdated: "2026-02-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2a4a90f5b52f61e7c9ae68c4863e7a325a34f436841ba6c7a1c8c03ee8e11447.png",
    creationTool: "cursor",
  },
  {
    id: "trends-hub",
    name: "Trends Hub",
    path: "/cc/trends-hub",
    description:
      "Trends discovery page showcasing trending products organized by theme. Features filter toggles and product grids for each trend category.",
    owner: "Chris Chappelle",
    createdAt: "2026-01-06",
    lastUpdated: "2026-01-15",
    surfaceArea: "Retailer",
    category: "experimental",
    project: "Trends",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/3721ba22d4b543d92060f0e936648e76eac9f0fb9f9b592c6d58f0a4c3a8ddbc.png",
    creationTool: "cursor",
  },
  {
    id: "grid-refinement",
    name: "Grid refinement",
    path: "/cc/grid-refinement",
    description:
      "Responsive layout refinement for Trends product grid. Breakpoints: mobile 2 cols, tablet 4, desktop 5, x-large 6. Based on Figma Trends Hub design.",
    owner: "Chris Chappelle",
    createdAt: "2026-01-30",
    lastUpdated: "2026-02-27",
    surfaceArea: "Retailer",
    category: "experimental",
    project: "Trends",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/54520c07e62e8e8d61b88f2d46d5fdf0098604189aa8dad1316c5ce71a6ac99e.png",
    creationTool: "cursor",
  },
  {
    id: "cc-add-to-cart-button",
    name: "Add to cart button",
    path: "/cc/add-to-cart-button",
    description: "",
    owner: "Chris Chappelle",
    createdAt: "2026-05-10",
    lastUpdated: "2026-05-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/b9fc565c863b9c8847a2770ff95f44f4a7e06108fbfdbd2d8192d23ea06b3f3c.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-pdp-explorations-native-pdp-atc",
    name: "Native PDP ATC",
    path: "/cc/pdp-explorations-native-pdp-atc",
    description: "",
    owner: "Chris Chappelle",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/30be3b0c42396ee679db7a258d3b0e7c5c54be4440c21b262470c391491f3c56.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-verified-pricing",
    name: "PDP Verified Pricing",
    path: "/cc/verified-pricing",
    description:
      "Product detail page with verified pricing information from external sources",
    owner: "Chris Chappelle",
    createdAt: "2026-05-27",
    lastUpdated: "2026-05-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    project: "PDP Explorations",
    thumbnail: "/images/thumbnails/cc-verified-pricing.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-feed-content-explorations-r-2",
    name: "Feed Content Explorations R2",
    path: "/cc/feed-content-explorations-r-2",
    description:
      "R2 iteration of feed content explorations with infinite scroll, focusing on full-width products layout",
    owner: "Chris Chappelle",
    createdAt: "2026-06-12",
    lastUpdated: "2026-06-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/26f5d430aa05d5adfa04fc7fb9b334b55bce65f830ded813238bbd5ac6c25db9.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-app-cart-animation",
    name: "App Cart Animation",
    path: "/cc/app-cart-animation",
    description: "",
    owner: "Chris Chappelle",
    createdAt: "2026-06-17",
    lastUpdated: "2026-06-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.faire.com/fastly/01373565d1587dfc0178013fcec2929f03148d2d5b163026c029a6a223d16c4c.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-brand-page-copy",
    name: "Brand Page Copy",
    path: "/cc/brand-page-copy",
    description: "Direct copy of the Faire brand page for prototyping edits",
    owner: "Chris Chappelle",
    createdAt: "2026-06-24",
    lastUpdated: "2026-06-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/f5f88aa77e6a2977c517fd4edae4b18d761b2175127aabd69f55505d7c224607.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-liquid-glass-ios",
    name: "Liquid Glass iOS",
    path: "/cc/liquid-glass-ios",
    description:
      "Foundation for native iOS prototypes: reusable Liquid Glass nav bar, tab bar, and motion, demonstrated over scrollable content.",
    owner: "Chris Chappelle",
    createdAt: "2026-07-10",
    lastUpdated: "2026-07-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "https://cdn.faire.com/fastly/e958846ffd25e07f87057125a10143da0adf194d00d0bb7678d57c1ebbff5c1b.png",
    project: "Liquid Glass",
    creationTool: "claude-code",
  },
  {
    id: "cc-save-to-collection",
    name: "Save to Collection",
    path: "/cc/save-to-collection",
    description:
      "Save a product from a discovery grid and add it to collections via an anchored module",
    owner: "Chris Chappelle",
    createdAt: "2026-07-22",
    lastUpdated: "2026-07-22",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/ff5c357148fb72e5ece76e82081879747c5b614998fd7ac7d86ff99357d213c5.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-pdp-atc-stepper",
    name: "Native PDP ATC — Stepper",
    path: "/cc/pdp-atc-stepper",
    description:
      "Mobile PDP add-to-cart variation using an inline quantity stepper next to the CTA, with in-cart / update / remove states.",
    owner: "Chris Chappelle",
    createdAt: "2026-08-10",
    lastUpdated: "2026-08-10",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    thumbnail: "/images/thumbnails/cc-pdp-atc-stepper.png",
    creationTool: "claude-code",
  },
  {
    id: "cc-saved-products-cart",
    name: "Saved Products & Cart",
    path: "/cc/saved-products-cart",
    description: "Weaves the home feed, favorites-collection popover, and cart to explore how saved products surface in the cart.",
    owner: "Chris Chappelle",
    createdAt: "2026-08-15",
    lastUpdated: "2026-08-15",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/cc-saved-products-cart.png",
    creationTool: "claude-code",
  }
];
